import { Headset } from "lucide-react";

import type { TIconProps } from "./types";

// NOTE: NSAI-6651 — every main-sidebar glyph comes from ONE family (lucide's
// 24px outline grid), drawn with the same stroke recipe. This was a hand-drawn
// filled outline on a 20px grid, sitting in the rail next to lucide strokes,
// so the column mixed two optical sizes, two line weights and two styles.
export const CallAssistant = (props: TIconProps): JSX.Element => (
  <Headset
    stroke="var(--fill1)"
    style={{ strokeWidth: "calc(1.5 + var(--nav-glyph-bold, 0) * 1.2)" }}
    {...props}
  />
);
